
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { FranchiseType, FranchisePayloadType } from "@/common/types/franchise";

export async function franchiseList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `franchise/list${queryString}`
    );
}

export async function franchiseGet(
    franchise_id: string
) {
    return await clientAxios.get(
        `franchise/${franchise_id}/show`
    );
}

export async function franchiseAdd(
    payload: FranchisePayloadType
) {
    return await clientAxios.post(
        `franchise/create`,
        payload
    );
}

export async function franchisePatch(
    franchise_id: string,
    payload: Partial<FranchiseType>
) {
    return await clientAxios.patch(
        `franchise/${franchise_id}/patch`,
        { payload }
    );
}

export async function franchiseDel(
    franchise_id: string,
) {
    return await clientAxios.del(
        `franchise/${franchise_id}/delete`,
    );
}
